import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { observable } from "mobx";
import { observer } from "mobx-react";

const fakeAuth = {
  isAuthenticated: false
  // authenticate(cb) {
  //   this.isAuthenticated = true;
  //   setTimeout(cb, 100); // fake async
  // },
  // signout(cb) {
  //   this.isAuthenticated = false;
  //   setTimeout(cb, 100);
  // }
};

class LoggedInRoute extends React.Component {
  @observable hasToken = false;
  @observable statusHired = false;

  constructor() {
    super();

    this.state = {
      isLoggedIn: true
    };
  }

  // getToken = () => {
  //   if (JSON.parse(localStorage.getItem("userData"))) {
  //     return JSON.parse(localStorage.getItem("userData")).token;
  //   }
  // };

  // getStatus = () => {
  //   // console.log(JSON.parse(localStorage.getItem("userData")));
  //   if (JSON.parse(localStorage.getItem("userData"))) {
  //     return JSON.parse(localStorage.getItem("userData")).data.status;
  //   }
  // };

  // componentDidMount() {
  //   if (this.getToken() && this.getToken().length) {
  //     // this.setState({ hasToken: true })
  //     this.hasToken = true;
  //   }
  //   if (this.getStatus() && this.getStatus() === "HIRED") {
  //     this.statusHired = true;
  //   }
  // }

  // componentWillReceiveProps() {
  //   if (this.getToken() && this.getToken().length) {
  //     // this.setState({ hasToken: true })
  //     this.hasToken = true;
  //   }
  //   if (this.getStatus() && this.getStatus() === "HIRED") {
  //     this.statusHired = true;
  //   }
  // }

  render() {
    const RouteComponent = this.props.component;

    const userData = JSON.parse(localStorage.getItem("userData"));
    // console.log(userData.token);
    console.log("Hello", this.props);
    return (
      <Route
        {...this.props}
        component={() =>
          userData && userData.token && userData.token.length ? (
            <RouteComponent />
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: this.props.location }
              }}
            />
          )
        }
      />
    );
  }
}

{
  /* <Route
        {...this.props}
        render={props =>
          this.state.isLoggedIn ? (
            <RouteComponent {...props} />
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: props.location }
              }}
            />
          )
        }
      /> */
}

export default LoggedInRoute;
